module.exports = __webpack_public_path__ + "static/media/generalSurgery-image3@2x.9d751847.png";